import { NotifyType } from '../../components/Notification'
import { axiosInstance } from '../Middleware'
import { DemandeAbsenceType  } from './types'
import { DocumentData, DocumentInfo } from '../../modules/NouvelleDemande/NouvelleDemande.types'
import { DocumentApi } from '../Document/DocumentApi'

export class DemandeAbsenceApi {
  public static loadDemandesAbsence = async(complement?: string, notify?: NotifyType, silent?: boolean) : Promise<DemandeAbsenceType[]> => {
    try{
      const response = await axiosInstance.get(`/personnel/personnel/demandesabsences?perPage=400${complement ? `&${complement}` : ''}`, silent ? { silent: true } as any : undefined)
      return response.data.data.map((demande: DemandeAbsenceType) => {
        let etat;
        switch (demande.statut) {
            case -1:
              if (demande.valide === 0) {
                 etat = 'refusees'
              } else {
                etat = 'annulees'
              }
              break
            case 0:
              etat = 'enCours'
              break
            case 1:
              etat = 'acceptees'
              break
            default:
              break
          }
        return ({
          ...demande,
          etat
        })
      })
    } catch (error) {
       notify?.error('Erreur lors de la récupération des demandes d\'absence:' + error, 2000)
      return null as any;
    }

  }

  public static createDemandeAbsence = async (
    data: DemandeAbsenceType,
    documentData?: DocumentData,
    identifiantEntite?: number,
    notify?: NotifyType
  ): Promise<DemandeAbsenceType> => {
    try {
      // Étape 1: Créer la demande d'absence SANS document d'abord
      const demandeDataWithoutDocument = {
        ...data,
        piecesjointes: 0 // Initialiser à 0, sera mis à jour après l'ajout du document
      }

      const demandeResponse = await axiosInstance.post('/personnel/personnel/demandesabsences', demandeDataWithoutDocument)

      if (!demandeResponse.data || !demandeResponse.data.identifiant) {
        throw new Error('Échec de la création de la demande d\'absence')
      }

      const demandeCreee = demandeResponse.data

      // Étape 2: Si un document est fourni, l'ajouter via DocumentApi
      if (documentData?.file) {
        try {
          // Utiliser DocumentApi avec le type de document pour demandes d'absence
          const documentResponse: any = await DocumentApi.postDocument(
            documentData.file,
            {
              type: 'Piecejoint', // Type de document spécifique
              identifiantOrigine: data.identifiantAgent, // ID de la demande comme origine
              identifiantEntite,
              description: documentData.description || '',
            }
          )

          // Mettre à jour la demande pour indiquer qu'elle a une pièce jointe
          const updatedDemande = await axiosInstance.put(`/personnel/personnel/demandesabsences/${demandeCreee?.identifiant}`, {
            ...demandeCreee,
            piecesjointes: documentResponse.identifiant
          })

          return updatedDemande.data
        } catch (documentError) {
          console.warn('Erreur ajout document, demande créée sans document:', documentError)
          // La demande a été créée, mais pas le document - on peut continuer
        }
      }
      return demandeCreee
    } catch (error) {
      console.error('[CreateDemandeWithDoc] Erreur:', error)
      notify?.error('Erreur lors de la création de la demande avec document: ' + error, 2000)
      throw error
    }
  }

  public static updateDemandeAbsence = async (
    identifiant: number,
    data: DemandeAbsenceType,
    identifiantEntite?: number,
    documentData?: DocumentData,
    deleteDocument?: boolean,
    notify?: NotifyType
  ): Promise<DemandeAbsenceType> => {
    try {
      console.log('📋 [UpdateDemandeWithDoc] Mise à jour demande ID:', identifiant)

      // D'abord, mettre à jour les données de la demande
      const updatedData = {
        ...data,
        piecesjointes: deleteDocument ? 0 : data.piecesjointes
      }

      if(deleteDocument && data.piecesjointes){
        await axiosInstance.delete(`/personnel/personnel/documents/${data.piecesjointes}`)
      }

      if(documentData?.file){
        const documentResponse = await DocumentApi.postDocument(
            documentData.file,
            {
              type: 'Piecejoint', // Type de document spécifique
              identifiantOrigine: data.identifiantAgent, // ID de la demande comme origine
              identifiantEntite,
              description: documentData.description || '',
            }
          )
          updatedData.piecesjointes = documentResponse.identifiant
      }

      const response = await axiosInstance.put(`/personnel/personnel/demandesabsences/${identifiant}`, updatedData)

      return response.data
    } catch (error) {
      console.error('[UpdateDemandeWithDoc] Erreur:', error)
      notify?.error('Erreur lors de la modification de la demande: ' + error, 2000)
      throw error
    }
  }

  public static deleteDemandeAbsence = async(identifiant: number, notify?: NotifyType) : Promise<{ success: boolean }> =>{
    try{
      await axiosInstance.delete(`/personnel/personnel/demandesabsences/${identifiant}`)
      notify?.success('Demande d\'absence supprimée avec succès')
      return { success: true }
    } catch(error) {
      notify?.error('Erreur lors de la suppression de la demande:' + error, 2000)
      throw error
    }
  }

  public static downloadDocument = async (identifiant: number, notify?: NotifyType): Promise<Blob> => {
    try {
      const response = await axiosInstance.get(`/personnel/personnel/demandesabsences/${identifiant}/document`, {
        responseType: 'blob'
      })

      console.log('response : ', response);

      return response.data
    } catch (error) {
      notify?.error('Erreur lors du téléchargement du document: ' + error, 2000)
      throw error
    }
  }

  public static getDocumentInfo = async (identifiant: number, notify?: NotifyType): Promise<DocumentInfo> => {
    try {
      const response = await axiosInstance.get(`/personnel/personnel/demandesabsences/${identifiant}/document/info`)
      return response.data
    } catch (error: any) {
      // Ne pas notifier l'utilisateur pour les erreurs 404 (pas de document)
      if (error?.response?.status === 404) {
        throw error // Relancer l'erreur sans notification
      }

      // Pour les autres erreurs, notifier l'utilisateur
      notify?.error('Erreur lors de la récupération des informations du document: ' + error, 2000)
      throw error
    }
  }
  public static getDemandesAValider = async (identifiantAgent: number): Promise<DemandeAbsenceType[]> => {
    const response = await axiosInstance.get(`/personnel/personnel/demandesabsences/${identifiantAgent}/a-valider`)
    return response.data.data;
  }
}
